import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Term } from "./terms";
import { TermsService } from "./terms-service";
import './terms-modal.css'; // We'll create this CSS file next

interface TermsModalProps {
  show: boolean;
  onAccept: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({ show, onAccept }) => {
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const termsService = new TermsService();

  const handleAccept = async () => {
    if (!accepted) return;
    
    setSubmitting(true);
    try {
      const result = await termsService.updateUserTerms();
      if (!result.error) {
        onAccept();
      } else {
        console.error("Failed to accept terms:", result.error);
        // Show error message
      }
    } catch (error) {
      console.error("Error accepting terms:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal 
      show={show} 
      backdrop="static" 
      keyboard={false} 
      size="lg"
      className="terms-modal"
      centered
      style={{ zIndex: 1050 }}
    >
      <Modal.Header>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="terms-modal-content">
          <Term />
        </div>
      </Modal.Body>
      <Modal.Footer className="d-block">
        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            id="accept-terms"
            label="I have read and accept the terms and conditions"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
        </Form.Group>
        <Button 
          variant="primary" 
          disabled={!accepted || submitting} 
          onClick={handleAccept}
        >
          {submitting ? 'Accepting...' : 'Accept'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}; 